import { CalendarDays, Clock, FileClock, Landmark, LifeBuoy, UserRound } from "lucide-react";
import { AppShell, type NavItem } from "../../components/AppShell";
import { useAuth } from "../../context/AuthContext";

export const EMPLOYEE_NAV: NavItem[] = [
  { to: "/me", label: "My Clock", slug: "my-clock", icon: Clock, end: true },
  { to: "/me/profile", label: "My Profile", slug: "my-profile", icon: UserRound },
  { to: "/me/assignments", label: "Assignments", slug: "assignments", icon: CalendarDays },
  { to: "/me/timesheets", label: "Timesheets", slug: "my-timesheets", icon: FileClock },
  { to: "/me/payment-method", label: "Payment method", slug: "payment-method", icon: Landmark },
  { to: "/me/help", label: "Help", slug: "help", icon: LifeBuoy },
];

export default function EmployeeLayout() {
  const { session } = useAuth();
  const e = session?.employee;
  return (
    <AppShell
      nav={EMPLOYEE_NAV}
      testId="employee-shell"
      homePath="/me"
      userName={e?.full_name ?? "Crew member"}
      userEmail={e?.email ?? ""}
      isDemo={e?.is_demo ?? false}
      roleLabel="Crew"
    />
  );
}
